module.exports = __webpack_public_path__ + "static/media/c.65c32eb7.png";